import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/app/src/components/I18nProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/SessionProviderWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/PushRegister.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/tailwind.css");
